document.addEventListener('DOMContentLoaded', function() {
    // Target only links that end with "-modal"
    var modalLinks = document.querySelectorAll('a[href*="-modal"]');

    // Add click event listeners to each targeted modal link
    modalLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent the link from navigating

            // Get the target modal based on the href attribute of the clicked link
            var modalId = link.getAttribute('href').substring(1);
            var modal = document.getElementById(modalId);

            if (modal) {
                modal.style.display = 'block';
            }
        });
    });

    // Close buttons functionality remains unchanged
    var closeButtons = document.querySelectorAll('.close');
    closeButtons.forEach(function(closeBtn) {
        closeBtn.addEventListener('click', function() {
            var modal = closeBtn.closest('.overlay');
            if (modal) {
                modal.style.display = 'none';
            }
        });
    });

    // Improved the outside click logic to prevent closing modals unintentionally
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('overlay')) {
            event.target.style.display = 'none';
        }
    });
});